// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__gS4Vt","field":"Form_field__W4ZCE","message":"Form_message__6VxJk","required":"Form_required__CSRvT"};